/* eslint-disable camelcase */
import { apiSliceType as api } from '../../api/apiSlice';

export const addTagTypes = ['MoodMeter', 'User'] as const;
const injectedRtkApi = api
    .enhanceEndpoints({
        addTagTypes,
    })
    .injectEndpoints({
        endpoints: (build) => ({
            postMoodmeterSubmitMoodMeter: build.mutation<
                PostMoodmeterSubmitMoodMeterApiResponse,
                PostMoodmeterSubmitMoodMeterApiArg
            >({
                query: (queryArg) => ({
                    url: `/moodmeter/submit_mood_meter`,
                    method: 'POST',
                    body: queryArg.moodMeterRequest,
                }),
                invalidatesTags: ['MoodMeter'],
            }),
            getMoodmeterCountUsersGroupMood: build.query<
                GetMoodmeterCountUsersGroupMoodApiResponse,
                GetMoodmeterCountUsersGroupMoodApiArg
            >({
                query: (queryArg) => ({
                    url: `/moodmeter/count_users_group_mood`,
                    params: { supervisor_number: queryArg.supervisorNumber, filter: queryArg.filter },
                }),
                providesTags: ['MoodMeter'],
            }),
            getMoodmeterNameUsersGroupMood: build.query<
                GetMoodmeterNameUsersGroupMoodApiResponse,
                GetMoodmeterNameUsersGroupMoodApiArg
            >({
                query: (queryArg) => ({
                    url: `/moodmeter/name_users_group_mood`,
                    params: {
                        supervisor_number: queryArg.supervisorNumber,
                        moodType: queryArg.moodType,
                        filter: queryArg.filter,
                    },
                }),
                providesTags: ['MoodMeter'],
            }),
            getUserAboutMePersonalization: build.query<
                GetUserAboutMePersonalizationApiResponse,
                GetUserAboutMePersonalizationApiArg
            >({
                query: (queryArg) => ({
                    url: `/user/about_me_personalization`,
                    params: { employeeNumber: queryArg.employeeNumber },
                }),
                providesTags: ['User'],
            }),
            getUserUserActivityCount: build.query<
                GetUserUserActivityCountApiResponse,
                GetUserUserActivityCountApiArg
            >({
                query: (queryArg) => ({
                    url: `/user/user_activity_count`,
                    params: { employeeNumber: queryArg.employeeNumber },
                }),
                providesTags: ['User'],
            }),
        }),
        overrideExisting: false,
    });
export { injectedRtkApi as enhancedApi };
export type PostMoodmeterSubmitMoodMeterApiResponse = /** status 200 Success */ BooleanApiResponse;
export type PostMoodmeterSubmitMoodMeterApiArg = {
    moodMeterRequest: MoodMeterRequest;
};
export type GetMoodmeterCountUsersGroupMoodApiResponse =
    /** status 200 Success */ MoodMeterAgentsGroupIEnumerableApiResponse;
export type GetMoodmeterCountUsersGroupMoodApiArg = {
    supervisorNumber?: string;
    filter?: string;
};
export type GetMoodmeterNameUsersGroupMoodApiResponse =
    /** status 200 Success */ MoodMeterUserIEnumerableApiResponse;
export type GetMoodmeterNameUsersGroupMoodApiArg = {
    supervisorNumber?: string;
    moodType?: string;
    filter?: string;
};
export type GetUserAboutMePersonalizationApiResponse =
    /** status 200 Success */ AboutMePersonalizationListApiResponse;
export type GetUserAboutMePersonalizationApiArg = {
    employeeNumber: string;
};
export type GetUserUserActivityCountApiResponse = /** status 200 Success */ Int32ApiResponse;
export type GetUserUserActivityCountApiArg = {
    employeeNumber: string;
};
export type BooleanApiResponse = {
    statusCode?: number;
    message?: string | null;
    data?: boolean;
    status?: boolean;
};
export type MoodMeterRequest = {
    oracleId?: string | null;
    supervisorId?: string | null;
    moodType?: string | null;
};
export type MoodMeterAgentsGroup = {
    mood_type?: string | null;
    count?: number;
};
export type MoodMeterAgentsGroupIEnumerableApiResponse = {
    statusCode?: number;
    message?: string | null;
    data?: MoodMeterAgentsGroup[] | null;
    status?: boolean;
};
export type MoodMeterUser = {
    employee_number?: string | null;
    first_name?: string | null;
    middle_name?: string | null;
    last_name?: string | null;
};
export type MoodMeterUserIEnumerableApiResponse = {
    statusCode?: number;
    message?: string | null;
    data?: MoodMeterUser[] | null;
    status?: boolean;
};
export type AboutMePersonalization = {
    employee_number?: string | null;
    emp_name?: string | null;
    hire_date?: string | null;
    personalization_id?: number | null;
    about_me_description?: string | null;
    emp_language_id?: number | null;
    email_address?: string | null;
    phone_number?: string | null;
    manager_number?: string | null;
    manager_first_name?: string | null;
    manager_middle_name?: string | null;
    manager_last_name?: string | null;
};
export type AboutMePersonalizationListApiResponse = {
    statusCode?: number;
    message?: string | null;
    data?: AboutMePersonalization[] | null;
    status?: boolean;
};
export type Int32ApiResponse = {
    statusCode?: number;
    message?: string | null;
    data?: number;
    status?: boolean;
};
export const {
    usePostMoodmeterSubmitMoodMeterMutation,
    useGetMoodmeterCountUsersGroupMoodQuery,
    useGetMoodmeterNameUsersGroupMoodQuery,
    useGetUserAboutMePersonalizationQuery,
    useGetUserUserActivityCountQuery,
} = injectedRtkApi;
